<template>
  <div>
    <ul class="list-unstyled rates-additional-info">
      <li
        v-for="(incl, i) in row.flatMap(r => r.rateData.rate.include)"
        :key="i"
      >
        <bridge8-popover
          header-prefix="Included Rate: "
          trigger="click"
          :text-callback="obj => obj.name"
          :obj="incl"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import Bridge8Popover from './Bridge8Popover'

export default {
  name: 'CalcRatesTableCellInclude',
  props: {
    row: {
      type: Array,
      required: true
    }
  },
  components: {
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellInclude.vue